<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Morfemenbord" [steps]="0" />

  <rid-mechanic-content>
    @for (v of [version()]; track v) {
      <div class="absolute grid justify-items-center gap-16" animate.leave="anim-fade-out">
        <div class="relative min-h-32 w-full">
          <div class="absolute bottom-0 flex w-full items-center gap-4">
            <rid-text-input class="w-full" animate.enter="wait-500 anim-pop-in" ridSfx="BUBBLE_POP">
              <div class="flex items-center place-self-center">
                <rid-vertical-spacer>
                  <rid-compressable-klank-card content="x" />
                </rid-vertical-spacer>

                <div class="grid flex-1 items-center" style="grid-template-columns: 1fr auto 1fr">
                  <div class="flex items-center justify-end">
                    @if (prefix(); as prefix) {
                      <rid-compressable-klank-card
                        #prefixCard
                        class="font-bold text-blue-500"
                        [content]="stripDashes(prefix)"
                        animate.enter="anim-pop-in"
                        ridSfx="BUBBLE_POP"
                      />
                    } @else if (step() === 'MORPHEMES') {
                      <div
                        class="border-surface-300 mx-1 inline-flex h-full min-w-16 items-center rounded-md border-3 border-dashed px-4 py-4 text-3xl text-slate-300 select-none"
                        animate.enter="anim-pop-in"
                      >
                        &nbsp;
                      </div>
                    }
                  </div>

                  <div class="flex items-center">
                    @for (k of keyboardComp.content(); track $index) {
                      <rid-syllabic-card #syllabicCard [value]="k" [highlightRule]="isStemChangingSuffix()" animate.enter="anim-pop-in" />
                    }
                    @for (k of keyboardComp.postfix(); track $index) {
                      <rid-syllabic-card #syllabicCard [value]="k" [highlightRule]="isStemChangingSuffix()" animate.enter="anim-fade-in" />
                    }

                    @if (keyboardComp.isEmpty()) {
                      <div
                        class="mx-1 inline-flex h-full items-center rounded-md border-3 px-4 py-4 text-3xl select-none"
                        [class]="
                          isStemChangingSuffix()
                            ? 'border-morpheme-stem text-morpheme-stem border-dotted font-bold'
                            : 'border-surface-300 border-dashed text-slate-300'
                        "
                        animate.enter="anim-pop-in"
                      >
                        ⋯
                      </div>
                    }
                  </div>

                  <div class="flex items-center justify-start">
                    @if (suffix(); as suffix) {
                      <rid-compressable-klank-card
                        #suffixCard
                        [class]="suffixCardClass()"
                        [content]="stripDashes(suffix)"
                        animate.enter="anim-pop-in"
                        ridSfx="BUBBLE_POP"
                      />
                    } @else if (step() === 'MORPHEMES') {
                      <div
                        class="border-surface-300 mx-1 inline-flex h-full min-w-16 items-center rounded-md border-3 border-dashed px-4 py-4 text-3xl text-slate-300 select-none"
                        animate.enter="anim-pop-in"
                      >
                        &nbsp;
                      </div>
                    }
                  </div>
                </div>
              </div>
            </rid-text-input>

            <div class="flex flex-col gap-4" animate.enter="wait-500 anim-pop-in">
              @if (step() === 'MORPHEMES') {
                <rid-button appearance="DANGER" [disabled]="true">
                  <i-backspace class="size-[1lh]" />
                </rid-button>
                <rid-button [disabled]="isEvaluating()" (click)="continue()">
                  <i-enter class="size-[1lh]" />
                </rid-button>
              } @else {
                <rid-button appearance="DANGER" [disabled]="isEvaluating()" (click)="backspace()">
                  <i-backspace class="size-[1lh]" />
                </rid-button>
                <rid-button [disabled]="isEvaluating() || keyboardComp.isEmpty()" (click)="okay()">
                  <i-enter class="size-[1lh]" />
                </rid-button>
              }
            </div>
          </div>
        </div>

        <div class="grid w-full" animate.enter="wait-500 anim-pop-in">
          <div
            style="grid-area: 1 / 1"
            class="flex justify-center"
            [class.invisible]="step() !== 'MORPHEMES'"
            [class.pointer-events-none]="step() !== 'MORPHEMES'"
            [class.anim-pop-in]="step() === 'MORPHEMES'"
          >
            <rid-morpheme-keyboard
              class="w-full"
              [prefixDisabled]="isEvaluating()"
              [suffixDisabled]="isEvaluating()"
              (prefixPressed)="onPrefixPressed($event)"
              (suffixPressed)="onSuffixPressed($event)"
            />
          </div>

          <div
            style="grid-area: 1 / 1"
            class="flex justify-center"
            [class.invisible]="step() !== 'CENTER'"
            [class.pointer-events-none]="step() !== 'CENTER'"
            [class.anim-pop-in]="step() === 'CENTER'"
          >
            <rid-functional-syllabic-keyboard
              #keyboardComp
              [isDisabled]="isEvaluating() || step() !== 'CENTER'"
              [layout]="centerLayout"
              mode="KLANK"
              (incorrected)="overlayFeedback.showIncorrect()"
            />
          </div>
        </div>
      </div>
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
